import React, { useEffect, useState } from "react";
import data from "../../data/carousel";
import Swiper from "swiper";
import Slide from "../Slide";
import { swiperFix } from "../Map";

const Carousel = () => {
  const { slides } = data;

  const [carousel, setCarousel]: [any, Function] = useState();
  const [isPlay, setIsPlay]: [Boolean, Function] = useState(false);

  useEffect(() => {
    setCarousel(
      new Swiper(".mmmTapesWalmart-carousel", {
        preloadImages: false,
        loop: true,
        lazy: {
          loadOnTransitionStart: true,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      })
    );
  }, []);

  useEffect(() => {
    swiperFix();
  }, []);

  const handleAutoplay = () => {
    isPlay ? carousel.autoplay.start() : carousel.autoplay.stop();
    setIsPlay(!isPlay);
  };

  return (
    <div id="mmmTapesWalmart-carousel-container" role="navigation">
      <div className="mmmTapesWalmart-carousel swiper-container">
        <div className="swiper-wrapper">
          {slides.map((slide: any, i: any) => (
            <Slide slide={slide} key={i} />
          ))}
        </div>

        <div className="swiper-pagination-box">
          <div
            className={`swiper-play-control ${isPlay ? "" : "paused"}`}
            onClick={handleAutoplay}
          ></div>
          <div className="swiper-pagination"></div>
        </div>
      </div>
    </div>
  );
};

export default Carousel;
